import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0c7dba2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crud-search__actions" }

import { Refresh, Search } from '@element-plus/icons-vue'
import type { CrudSearchItem } from '@/types/crud-config'


export default /*#__PURE__*/_defineComponent({
  __name: 'CrudSearch',
  props: {
    loading: { type: Boolean, default: false },
    model: { default: () => ({}) },
    items: { default: () => [] }
  },
  emits: ["search", "reset"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const fullDayDefaultTime: [Date, Date] = [
  new Date(2000, 0, 1, 0, 0, 0),
  new Date(2000, 0, 1, 23, 59, 59)
]

const handleSearch = () => {
  if (!props.loading) emit('search')
}

const handleReset = () => {
  if (!props.loading) emit('reset')
}

const handleEnter = (event: KeyboardEvent) => {
  if (event.isComposing || event.target instanceof HTMLTextAreaElement) return
  handleSearch()
}

const isDisabled = (item: CrudSearchItem) =>
  typeof item.disabled === 'function'
    ? item.disabled(props.model)
    : item.disabled

const getItemStyle = (item: CrudSearchItem) =>
  item.columnSpan
    ? { '--crud-search-column-span': String(item.columnSpan) }
    : undefined

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    class: "crud-search",
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "crud-search__fields",
        onKeyup: _withKeys(handleEnter, ["enter"])
      }, [
        (_ctx.items.length === 0)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 })
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createBlock(_component_el_form_item, {
                key: item.prop,
                label: item.label,
                class: _normalizeClass({ 'crud-search__item--spanned': item.columnSpan }),
                style: _normalizeStyle(getItemStyle(item))
              }, {
                default: _withCtx(() => [
                  (item.type === 'input')
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        modelValue: _ctx.model[item.prop],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.prop]) = $event),
                        class: _normalizeClass(item.controlClass),
                        clearable: item.clearable,
                        disabled: isDisabled(item),
                        placeholder: item.placeholder,
                        onChange: ($event: any) => (item.onChange?.($event, _ctx.model))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "clearable", "disabled", "placeholder", "onChange"]))
                    : (item.type === 'select')
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 1,
                          modelValue: _ctx.model[item.prop],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.prop]) = $event),
                          class: _normalizeClass(item.controlClass),
                          clearable: item.clearable,
                          disabled: isDisabled(item),
                          filterable: "",
                          loading: item.loading,
                          placeholder: item.placeholder,
                          onChange: ($event: any) => (item.onChange?.($event, _ctx.model))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.value,
                                label: option.label,
                                value: option.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "class", "clearable", "disabled", "loading", "placeholder", "onChange"]))
                      : (item.type === 'dateRange')
                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                            key: 2,
                            modelValue: _ctx.model[item.prop],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.prop]) = $event),
                            class: _normalizeClass(item.controlClass),
                            type: "daterange",
                            clearable: item.clearable,
                            disabled: isDisabled(item),
                            "disabled-date": item.disabledDate,
                            shortcuts: item.shortcuts,
                            "value-format": item.valueFormat,
                            "start-placeholder": item.startPlaceholder,
                            "end-placeholder": item.endPlaceholder,
                            onChange: ($event: any) => (item.onChange?.($event, _ctx.model))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "clearable", "disabled", "disabled-date", "shortcuts", "value-format", "start-placeholder", "end-placeholder", "onChange"]))
                        : (item.type === 'dateTimeRange')
                          ? (_openBlock(), _createBlock(_component_el_date_picker, {
                              key: 3,
                              modelValue: _ctx.model[item.prop],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.model[item.prop]) = $event),
                              class: _normalizeClass(item.controlClass),
                              type: "datetimerange",
                              clearable: item.clearable,
                              disabled: isDisabled(item),
                              "disabled-date": item.disabledDate,
                              "default-time": item.defaultTime || fullDayDefaultTime,
                              shortcuts: item.shortcuts,
                              "value-format": item.valueFormat,
                              "start-placeholder": item.startPlaceholder,
                              "end-placeholder": item.endPlaceholder,
                              onChange: ($event: any) => (item.onChange?.($event, _ctx.model))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "clearable", "disabled", "disabled-date", "default-time", "shortcuts", "value-format", "start-placeholder", "end-placeholder", "onChange"]))
                          : _renderSlot(_ctx.$slots, item.slot, {
                              key: 4,
                              item: item,
                              model: _ctx.model
                            })
                ]),
                _: 2
              }, 1032, ["label", "class", "style"]))
            }), 128)),
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "actions", {
            loading: _ctx.loading,
            search: handleSearch,
            reset: handleReset
          }, () => [
            _createVNode(_component_el_button, {
              disabled: _ctx.loading,
              onClick: handleReset
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Refresh), {
                  class: "crud-search__icon",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" 重置 ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _ctx.loading,
              onClick: handleSearch
            }, {
              default: _withCtx(() => [
                (!_ctx.loading)
                  ? (_openBlock(), _createBlock(_unref(Search), {
                      key: 0,
                      class: "crud-search__icon",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(" 搜索 ")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ], 32)
    ]),
    _: 3
  }))
}
}

})